/*jshint esversion: 6 */
export const namespaced = true;
import _ from 'lodash';
// import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff';
import * as turf from '@turf/turf'
import {surveillenceEventBus} from '../../util/surveillenceEventBus'
import * as util from "../../util/utility"

export const state= {
    surveillanceData: new Map(),
    surveillanceDataStatus:null,
    query:null,
    counter:0

}

export const mutations ={
    SET_UpdateSurveillanceData(state,payload){
        state.surveillanceDataStatus = payload

    },
    SET_Query(state,payload){
        state.query = payload
    }
}

export const actions = {
    
    async getSurveillance(context,query){
        try{
            let connectionStatus = context.rootGetters['connection/getConnectionStatus']
            if(connectionStatus){

                let socket = context.rootGetters['connection/getConnection'] 
                context.commit("SET_Query",query)
                context.commit("SET_UpdateSurveillanceData",false)

                socket.emit("requestsurveillanceData",query)
                socket.once("surveillanceData" ,(data)=>{
                   
                    context.dispatch('processSurveillanceData',data)
                    context.state.counter++
                })
                
            }
            
        }catch(e){
            console.log(e)
        }
    },
    processSurveillanceData(context,payload){
        
        state.surveillanceData.clear()
        let x = 0 
        for(let i=0;i<payload.length;i++){
            let newData = JSON.parse( payload[i])
                if(newData){
                    let key = String( newData.state.icao.address)
                    state.surveillanceData.set( key,newData)
                    // console.log(JSON.stringify( newData) )
                }//data received is not null
                x++
        }
        
        context.commit("SET_UpdateSurveillanceData",true)
        surveillenceEventBus.$emit("UpdateSurveillanceData",{})
        
    }
}

export const getters = {
    getSurveillanceData:(state)=>{
        return state.surveillanceData
    }
}

